<template>
  <v-dialog v-model="rhGraphModal" width="1420" height="1024">
    <v-card style="width:100%;height:100%;">
      <v-card-title primary class="title" style="height:10%;">Running Hours</v-card-title>
      <v-card-text>
        <div
            :id="'rhModalTabsContainer'"
            :style="
                  'width:100%; ' +
                  'height:calc(1024px * 0.7) !important; ' +
                  'max-height:calc(1024px * 0.7) !important; ' +
                  'overflow-y:auto; ' +
                  'padding: 0 16px;'
                "
        >
          <v-tabs
              :id="'rhModalTabs'"
              ref="rhModal"
              style="height:calc(1024px * 0.7)"
              :hide-slider="true"
          >
            <v-tab ripple active-class="activeTab" @click="toggleDetailsTab(false)"><span>Running hours</span></v-tab>
            <v-tab :id="'detailedTab'" ref="detailedTab" ripple active-class="activeTab" @click="toggleDetailsTab(true)">
              <span>Detailed view</span>
              <small id="detailedTabLoader" ref="detailedTabLoadingLabel" v-if="details_loading" :style="'margin-left: 4px;'"> (Loading...)</small>
            </v-tab>
            <v-radio-group
                row
                v-if="!details_loading && selectedDetailedView"
                v-model="screen"
                style="display:flex;justify-content:flex-end;align-items:center; margin-right: 6px;"
            >
              <v-radio flat value="table" label="Table of measurements" color="rgb(51,82,128)"/>
              <v-radio flat value="graphs" label="Graphs" color="rgb(51,82,128)"/>
              <v-btn
                  small
                  :disabled="disable_edit_signals_btn"
                  style="color:white; background-color: rgb(51,82,128); padding-left: 0; padding-right: 0;"
                  @click="openSignalsEdit"
              >
                Signals
              </v-btn>
            </v-radio-group>
            <v-tab-item style="height:calc(1024px * 0.6)">
              <Chart
                  v-bind:chartOptions="chartData"
                  v-bind:free="true"
                  v-bind:active="true"
              />
            </v-tab-item>
            <v-tab-item style="height:calc(1024px * 0.6)">
              <v-container v-if="!details_loading && !edit_visible_signals && screen=='table'" style="padding-left: 12px; padding-right: 12px">
                <dx-data-grid
                    id="rawTable"
                    ref='sigTable'
                    :data-source="signals"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :show-borders="true"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="true"
                >
                  <dx-paging :page-size="24"/>
                </dx-data-grid>
              </v-container>
              <Chart
                  v-if="!details_loading && !edit_visible_signals && screen=='graphs'"
                  v-bind:chartOptions="chartDataDetailed"
                  v-bind:free="true"
                  v-bind:active="false"
              />
              <v-container v-if="!details_loading && edit_visible_signals" style="padding-left: 12px; padding-right: 12px">
<!--                <v-layout column style="height: 100%; min-height:calc(1024px * 0.65); max-height:calc(1024px * 0.65); overflow-y: auto;">-->
                <v-layout column style="overflow-y: auto;">
                  <v-flex sm1 v-for="i in 7" :key="i">
                    <v-layout row>
                      <v-flex sm1 style="display: flex; align-items: center; padding-right: 4px; font-weight: 500; font-size: 1.25em;">
                        <span>Signal #{{ i }}</span>
                      </v-flex>
                      <v-flex sm11 style="display: flex; align-items: center; padding-left: 4px;">
                        <v-autocomplete
                            v-model="selected_signals[i-1]"
                            :items="available_signals_holders[i-1]"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row style="justify-content: end;">
                  <v-btn @click="cancelSignalEdit">Cancel</v-btn>
                  <v-btn @click="submitSignalEdit" style="color:white; background-color: rgb(51,82,128);">Submit</v-btn>
                </v-layout>
              </v-container>
              <v-container
                  v-if="details_loading"
                  style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;"
              >
                <v-progress-circular
                    :size="100"
                    :width="10"
                    indeterminate
                    color="primary"
                ></v-progress-circular>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {store} from "@/main";
import Chart from '@/components/Chart'
import axios from "axios";
import {DxColumn, DxDataGrid, DxFilterRow, DxHeaderFilter, DxLoadPanel, DxMasterDetail, DxPaging, DxSelection} from "devextreme-vue/data-grid";

export default {
  name: "TaskDetails",
  components: {
    Chart,
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxMasterDetail,
    DxSelection
  },
  props: {},
  data() {
    return {
      rhGraphModal: false,
      task: {},
      chartData: {},
      chartDataDetailed: {},
      screen: 'table',
      signals: null,
      details_loading: true,
      selectedDetailedView: false,
      disable_edit_signals_btn: false,
      edit_visible_signals: false,
      available_signals: {},
      available_signals_holders: [],
      selected_signals: [],
      selected_signals_bp: []
    }
  },
  methods: {
    loadDataDetails(signals) {
      this.details_loading = true;

      if (typeof signals == 'undefined') {
        this.screen = 'table';
        this.selectedDetailedView = false;
        this.disable_edit_signals_btn = false;
        this.edit_visible_signals = false;
      }

      this.selected_signals = [];

      return axios.post(store.config.api_location + `/maintenance/tasks/${this.task.id}/data`, {signals: signals}).then((res) => {
        if (res.data.success) {
          let tmp_signals = {}

          this.available_signals = res.data.data.available_signals;

          let tmp = 0;

          Object.keys(res.data.data.details.signals).map((parameter) => {
            if (Object.keys(this.available_signals).indexOf(parameter) > -1 && this.selected_signals.indexOf(this.available_signals[parameter]) < 0) {
              this.selected_signals.push(this.available_signals[parameter])
            }

            res.data.data.details.signals[parameter].values.map((pair) => {
              let parameter_title = res.data.data.details.signals[parameter].title;

              if (parameter.indexOf('rh') > -1) {
                if (tmp == 0) {
                  tmp = pair[0];
                }
              }

              tmp_signals[pair[0]] = tmp_signals[pair[0]] || {}
              tmp_signals[pair[0]]['date'] = new Date(pair[0])
              tmp_signals[pair[0]][parameter_title] = pair[1];
            });
          });

          this.signals = Object.values(tmp_signals);

          this.chartDataDetailed.series = [];
          this.chartDataDetailed.yAxis = [];

          let signals = Object.keys(res.data.data.details.signals).filter((item) => {
                if (['rh_diff', 'usage_rh_diff'].indexOf(item) < 0) {
                  return item
                }
              }),
              yAxisTop = {
                title: {
                  text: '',
                  align: 'high'
                },
                height: '45%'
              },
              yAxisBottom = {
                title: {
                  text: 'Running Hours',
                  align: 'high'
                },
                min: 0,
                top: '55%',
                height: '45%',
                offset: 0
              },
              opposite_threshold = Math.ceil(signals.length / 2);


          signals.map((item) => {
            let parameterAxis = JSON.parse(JSON.stringify(yAxisTop));
            parameterAxis.title.text = res.data.data.details.signals[item].title;
            parameterAxis.opposite = this.chartDataDetailed.yAxis.length >= opposite_threshold;

            this.chartDataDetailed.yAxis.push(parameterAxis)
            this.chartDataDetailed.series.push({
              name: res.data.data.details.signals[item].title,
              animation: false,
              data: res.data.data.details.signals[item].values.map((pair) => {
                return [pair[0], parseFloat(pair[1])];
              }),
              size: '100%',
              innerSize: '70%',
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
              yAxis: this.chartDataDetailed.yAxis.length - 1
            });
          });

          this.chartDataDetailed.yAxis.push(yAxisBottom)
          Object.keys(res.data.data.events).map((item) => {
            this.chartDataDetailed.series.push({
              name: res.data.data.events[item].title,
              animation: false,
              data: res.data.data.events[item].values,
              size: '100%',
              innerSize: '70%',
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
              yAxis: this.chartDataDetailed.yAxis.length - 1
            });
          });
        }

        this.details_loading = false;
      }).catch((e) => {
        this.details_loading = false;
      })
    },
    toggleDetailsTab(status) {
      this.selectedDetailedView = status;
    },
    openSignalsEdit() {
      this.edit_visible_signals = true;
      this.disable_edit_signals_btn = true;
      this.selected_signals_bp = JSON.parse(JSON.stringify(this.selected_signals));
    },
    cancelSignalEdit() {
      this.disable_edit_signals_btn = false
      this.edit_visible_signals = false
      this.selected_signals = JSON.parse(JSON.stringify(this.selected_signals_bp));
    },
    submitSignalEdit() {
      let selected_signal_parameters = Object.keys(this.available_signals).filter((parameter) => {
        return this.selected_signals.indexOf(this.available_signals[parameter]) > -1;
      });

      this.loadDataDetails(selected_signal_parameters).then(() => {
        this.disable_edit_signals_btn = false
        this.edit_visible_signals = false
      })
    },
    setModalActive(value) {
      this.rhGraphModal = value
    },
    setChartData(data) {
      this.chartData = data;
    },
    setChartDataDetailed(data) {
      this.chartDataDetailed = data;
    },
    setTask(data) {
      this.task = data;
    }
  },
  watch: {
    rhGraphModal: function () {
      if (this.rhGraphModal) {
        this.loadDataDetails();
      }
    },
    available_signals: {
      handler: function () {
        for (var i = 0; i <= 7; i++) {
          this.available_signals_holders[i] = Object.values(this.available_signals).filter((item, index) => {
            return this.selected_signals.indexOf(item) < 0 || this.selected_signals[i] == item
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>